import {Map} from 'immutable';
import {handleActions} from 'redux-actions';

import * as Actions from './actions';

export const behaviorsReducer = handleActions(
    {
        [Actions.fetchAllPresetsSuccess.type]: (state, {payload: {behaviors}}) => behaviors,
    },
    [],
);

export default handleActions(
    {
        [Actions.fetchAllPresetsSuccess.type]: (state, {payload: {presets}}) =>
            Map(presets.map(preset => [preset.discountPresetId, preset])),
        [Actions.updatePresetsSuccess.type]: (state, {payload: {presets}}) =>
            Map(presets.map(preset => [preset.discountPresetId, preset])),
    },
    Map(),
);
